module.exports = __webpack_public_path__ + "img/c-en-23.91dd20bd.png";